const Screen = () => {
	return (
		<>
            <div className="_container">
                <div className="_lily_pad_h_d" style={{marginTop: 100, marginBottom: 100}}>
                    <h1>Not Found</h1>
                    <p className="_push_t_m">opps, halaman atau data tidak ditemukan.</p>
                </div>
            </div>
		</>
	);
}

export default Screen;